import React, { useState, useEffect } from 'react';
import CountUp from 'react-countup';
import axios from 'axios';
import { useSelector } from 'react-redux';
import config from '../../../../config';
import canSeeFinance from '../../../../utils/canSeeFinance';
import { NdoeStats, NdoeStatCard } from '../../../../components/ndoe';

const RapportMoney = ({ start_date, end_date }) => {
    const [venteTotal, setVenteTotal] = useState([]);
    const [depenses, setDepenses] = useState([]);
    const DOMAIN = config.REACT_APP_SERVER_DOMAIN;
    const user = useSelector((state) => state.user?.currentUser);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const { data } = await axios.get(`${DOMAIN}/api/rapport/venteTotal/total?start_date=${start_date}&end_date=${end_date}`);
                setVenteTotal(data[0]?.montant_total_vente);
            } catch (error) {
                console.log(error);
            }
        };
        fetchData();
    }, [DOMAIN, start_date, end_date]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const { data } = await axios.get(`${DOMAIN}/api/depenses/caisseDepenseCount?date_start=${start_date}&date_end=${end_date}`);
                setDepenses(data[0]?.total_depense);
            } catch (error) {
                console.log(error);
            }
        };
        fetchData();
    }, [DOMAIN, start_date, end_date]);

    return (
        <NdoeStats>
            {/* Garde finance (Lot 0) : montant total de la vente réservé au rôle admin. */}
            {canSeeFinance(user) && (
                <NdoeStatCard
                    label="Montant total de la vente"
                    value={<><CountUp end={Number(venteTotal) || 0} /> $</>}
                />
            )}
            {/* Garde finance (Lot 0) : total des dépenses réservé au rôle admin. */}
            {canSeeFinance(user) && (
                <NdoeStatCard
                    gold
                    label="Montant total des dépenses"
                    value={<><CountUp end={Number(depenses) || 0} /> $</>}
                />
            )}
        </NdoeStats>
    );
};

export default RapportMoney;
